import "./styles/global";
import "katex/dist/katex.css";

import "@apps/flashcard/styles.css";
import "@apps/geogebra/styles.css";
import "@apps/i-ark/styles.css";
import "@apps/i-guide/styles.css";
import "@apps/image-hotspots/styles.css";
import "@apps/opgavekomplekset/styles.css";
import "@i-ark/components/styles.css";
import "@i-ark/hooks/styles.css";
import "@pm2/accordion-component/styles.css";
import "@pm2/bookshelf-page/styles.css";
import "@pm2/cards-component/styles.css";
import "@pm2/course-builder/styles.css";
import "@pm2/course-frontpage/styles.css";
import "@pm2/course-revisions/styles.css";
import "@pm2/cta-component/styles.css";
import "@pm2/descriptors-page/styles.css";
import "@pm2/element-toolbar/styles.css";
import "@pm2/flashcard-component/styles.css";
import "@pm2/geogebra-component/styles.css";
import "@pm2/glossary-word/styles.css";
import "@pm2/grid-component/styles.css";
import "@pm2/i-ark-component/styles.css";
import "@pm2/i-guide-component/styles.css";
import "@pm2/iframe-component/styles.css";
import "@pm2/image-component/styles.css";
import "@pm2/image-hotspots-component/styles.css";
import "@pm2/library-page/styles.css";
import "@pm2/media-component/styles.css";
import "@pm2/opgavekomplekset-component/styles.css";
import "@pm2/react-utils/styles.css";
import "@pm2/search/styles.css";
import "@pm2/slider-component/styles.css";
import "@pm2/split-component/styles.css";
import "@pm2/glossary-collection-component/styles.css";
import "@pm2/text-component/styles.css";
import "@pm2/ui-components/styles.css";
import "@pm2/ui-layout/styles.css";
import "@pm2/ui-lightbox/styles.css";
import "@pm2/user-area/styles.css";
import "@provider/print/styles.css";
import "@ui/css/styles.css";
import "@ui/kit/styles.css";
import "@utils/component-framework/styles.css";
import "@utils/css/styles.css";
import "@utils/next/styles.css";
import "@utils/react/styles.css";
import "@utils/richtexteditor/styles.css";

import { applyAuthzInterceptor, applyPreviewInterceptor } from "@pm2/api";
import { userIdentityStore } from "@provider/user-identity";

import type { AppProps } from "./app";
import { authenticateAndAuthorizeUser } from "./core/authz";
import { configurePm2UserIdentityManager } from "./core/config.user-identity-manager";

const appProps: AppProps = {
  configState: window.gConfig,
  sitemapState: {
    ...window.gSitemap,
    isSitemapResolved: false,
  },
};

configurePm2UserIdentityManager(appProps.configState);

authenticateAndAuthorizeUser(
  appProps.configState.config,
  window.gLoginConnectorToken,
)
  .then(({ authz, user }) => {
    // apply user data to global identity store
    userIdentityStore.dispatch(userIdentityStore.actions.setUser(user ?? null));

    // apply necessary interceptors for the Axios requests to run correctly
    applyAuthzInterceptor(authz);

    if (appProps.configState.previewMode) {
      applyPreviewInterceptor();
    }
  })
  .catch((reason) => {
    console.error("unable to authenticate and authorize user:", reason);

    alert(
      "Der opstod en fejl da vi forsøgte at logge dig på. Prøv evt. at genindlæse siden.",
    );
  });

import("./bootstrap.render")
  .then(({ renderApp }) => renderApp(appProps))
  .catch((err) => {
    alert("Der opstod en fejl ved indlæsning af portalen, vi beklager.");
    console.error(err);
  });

if (window.location.search.includes("ui-inspection=true")) {
  import("./dev.inspector-tool");
}
